export const receiveOffices = 'OFFICE/receiveOffices';
export const receiveOfficesView = 'OFFICE/receiveOfficesView';
export const receiveCreateOffice = 'OFFICE/receiveCreateOffice';
export const receiveUpdateOffice = 'OFFICE/receiveUpdateOffice';
export const removeOffice = 'OFFICE/removeOffice';
export const requestData = 'OFFICE/requestData';
